import { render, staticRenderFns } from "./BtPopup.vue?vue&type=template&id=445a1904&lang=pug&"
import script from "./BtPopup.vue?vue&type=script&lang=js&"
export * from "./BtPopup.vue?vue&type=script&lang=js&"
import style0 from "./BtPopup.vue?vue&type=style&index=0&id=445a1904&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports